import { render } from "./SharedGanttView.vue?vue&type=template&id=178ea05c&scoped=true"
import script from "./SharedGanttView.vue?vue&type=script&lang=js"
export * from "./SharedGanttView.vue?vue&type=script&lang=js"

import "./SharedGanttView.vue?vue&type=style&index=0&id=178ea05c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178ea05c"]])

export default __exports__